module.exports = __webpack_public_path__ + "img/shoulder-ecto-mesomorph-male.faa9f8b3.svg";